import { Amplify } from 'aws-amplify';

// This module MUST be imported before any module that calls generateClient().
// ES modules are evaluated left-to-right, so importing this file first in main.tsx
// ensures Amplify.configure() runs before any component module calls generateClient().
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [import.meta.env.VITE_REDIRECT_SIGN_IN || window.location.origin],
          redirectSignOut: [import.meta.env.VITE_REDIRECT_SIGN_OUT || window.location.origin],
          responseType: 'code',
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_APPSYNC_URL || '',
      region: import.meta.env.VITE_AWS_REGION || 'eu-west-2',
      defaultAuthMode: 'userPool',
    },
  },
});
